export function getStaticPageDetails(id) {
  return {
    path: `static-pages/${id}`
  };
}
